<div class="card rounded-top-left-0">
  <div class="card-header">
    <h1>Asociar Notas de Salida con COAs</h1>
  </div>

  <div class="card-body">
    <!-- Descripción -->
    <div class="mb-3 d-flex gap-3 align-items-end flex-wrap">
      <div class="text-muted">
        <i class="fa fa-circle-info"></i>
        Selecciona una <strong>nota de salida</strong> a la izquierda y marca los <strong>COAs</strong> a asociar a la derecha.
        <br>
        Una nota puede estar asociada a uno o más COAs.
      </div>
    </div>

    <div class="row">
      <!-- SVG para las líneas -->
      <svg id="svg-container" #svgContainer></svg>

      <!-- Tabla de Notas de Salida -->
      <div class="col">
        <label class="form-label">Buscar nota de salida</label>
        <input type="text" [(ngModel)]="filterExitNotes" (input)="refreshNotAssociatedPagination(); refreshAssociatedPagination()" class="form-control" placeholder="Número o proveedor" />

        <!-- 🔹 No asociadas -->
        <h5 class="mt-3">No Asociadas</h5>
        <div class="table-responsive mt-2">
          <table class="table table-bordered">
            <thead>
              <tr><th></th><th>Número</th><th>Proveedor</th><th>Fecha</th></tr></thead>
            <tbody>
              <tr *ngFor="let en of exitNotesNotAssociated"
                  (click)="selectExitNote(en.id)"
                  [class.selected]="en.id === selectedExitNoteId">
                <td><i [ngClass]="en.id === selectedExitNoteId ? 'fa-solid fa-circle' : 'fa-regular fa-circle'"></i></td>
                <td>{{ en.number }}</td>
                <td>{{ en.providerName }}</td>
                <td>{{ en.date }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <app-simple-pagination [elements]="paginationNotAssociated" (changed)="refreshNotAssociatedPagination()"></app-simple-pagination>

        <!-- 🔹 Asociadas -->
        <h5 class="mt-4">Asociadas</h5>
        <div class="table-responsive mt-2">
          <table class="table table-bordered">
            <thead>
              <tr><th></th><th>Número</th><th>Proveedor</th><th>Fecha</th></tr></thead>
            <tbody>
              <tr *ngFor="let en of exitNotesAssociated"
                  (click)="selectExitNote(en.id)"
                  [class.selected]="en.id === selectedExitNoteId">
                <td><i [ngClass]="en.id === selectedExitNoteId ? 'fa-solid fa-circle' : 'fa-regular fa-circle'"></i></td>
                <td>{{ en.number }}</td>
                <td>{{ en.providerName }}</td>
                <td>{{ en.date }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <app-simple-pagination [elements]="paginationAssociated" (changed)="refreshAssociatedPagination()"></app-simple-pagination>
      </div>


      <!-- Tabla de COAs -->
      <div class="col">
        <div class="form-group">
          <label class="form-label">Buscar COA</label>
          <input type="text"
                 [(ngModel)]="filterCoas"
                 (input)="debouncedFilterCoas()"
                 class="form-control"
                 placeholder="Código, número o producto" />
        </div>

        <div class="table-responsive mt-3">
          <table class="table table-bordered" id="table-coas">
            <thead>
              <tr class="tr-middle">
                <th></th>
                <th>Código</th>
                <th>Número</th>
                <th>Producto</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let c of coas"
                  [attr.data-id]="c.id"
                  (click)="toggleCoa(c)"
                  [class.selected]="currentAssociatedCoaIds.includes(c.id)">
                <td>
                  <i [ngClass]="currentAssociatedCoaIds.includes(c.id) ? 'fa-solid fa-circle' : 'fa-regular fa-circle'"></i>
                </td>
                <td>{{ c.code }}</td>
                <td>{{ c.number }}</td>
                <td>{{ c.productData?.name || '—' }}</td>
              </tr>
              <tr *ngIf="coas.length === 0">
                <td colspan="4" class="text-muted">
                  <i class="fa fa-circle-info"></i> No se encontraron COAs.
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <app-simple-pagination
          id="coas-pag"
          [sizes]="[5,10,20]"
          (changed)="refreshCoasPagination()"
          [elements]="paginationCoas">
        </app-simple-pagination>
      </div>
    </div>

    <!-- Detalles y Guardar -->
    <div class="row mt-4">
      <div class="col" *ngIf="exitNoteDetails.length > 0">
        <h5>Detalles de la Nota de Salida</h5>
        <div class="table-responsive table-bordered">
          <table class="table table-striped">
            <thead>
              <tr>
                <th>Código</th>
                <th class="text-right bg-warning-subtle">Cantidad</th>
                <th class="td-center bg-info-subtle">Unidad/Ítem</th>
                <th>Descripción</th>
                <th class="text-right">Cantidad Recibida</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let detail of exitNoteDetails">
                <td>{{ detail.productData.code }}</td>
                <td class="text-right bg-warning-subtle">{{ detail.quantity }}</td>
                <td class="td-center bg-info-subtle">{{ detail.item }}</td>
                <td>{{ detail.productData.name }}</td>
                <td class="text-right">{{ detail.quantityReceived }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="col" *ngIf="currentAssociatedCoas && currentAssociatedCoas.length > 0">
        <h5>COAs Asociados</h5>
        <ul class="list-group">
          <li *ngFor="let c of currentAssociatedCoas" class="list-group-item">
            <strong>{{ c.code }}</strong> — {{ c.productData?.name || '—' }}
          </li>
        </ul>
        <div class="col-12 mt-4" *ngIf="coaDetails && coaDetails.length > 0">
          <h5>Detalles del COA seleccionado</h5>

          <div *ngIf="loadingCoaDetails" class="text-muted">
            <i class="fa fa-spinner fa-spin"></i> Cargando detalles...
          </div>

          <div *ngIf="!loadingCoaDetails" class="table-responsive mt-2">
            <table class="table table-striped table-bordered">
              <thead>
                <tr>
                  <th>Parámetro</th>
                  <th>Método</th>
                  <th>Unidades</th>
                  <th>Valor</th>
                  <th>Comentario</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let d of coaDetails">
                  <td>{{ d.parameterData?.parameter || '—' }}</td>
                  <td>{{ d.parameterData?.method || '—' }}</td>
                  <td>{{ d.parameterData?.units || '—' }}</td>
                  <td>{{ d.value ?? '—' }}</td>
                  <td>{{ d.comment || '—' }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div *ngIf="selectedExitNoteId" class="d-flex flex-row justify-between mt-3">
        <button class="btn btn-success"
                [disabled]="getDisabledSave()"
                (click)="saveAssociations()">
          <ng-container *ngIf="!loading">
            <i class="fa fa-floppy-disk"></i>
          </ng-container>
          <ng-container *ngIf="loading">
            <span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
          </ng-container>
          GUARDAR CAMBIOS
        </button>
      </div>
    </div>
  </div>
</div>
